import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { VStack, Box } from '@chakra-ui/react';
import { CardCarousel, CardCarouselProps } from '@src/components/sco/CardCarousel';
import { TopControlTest } from '@src/components/sco/CardCarousel/Controls/TopControlTest';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { VideoCard } from '@src/components/sco/Education/VideoLanding/VideoCard';
import { gql } from '@src/lib/gql';
import React, { useEffect } from 'react';
import { Fade } from 'react-awesome-reveal';
type VideoListCarouselProps = {
  videos?: any[];
  typeSlug?: string;
  subjectLogo?: string;
  term?: string;
  carouselProps?: CardCarouselProps;
  onResults?: (hasResults: boolean) => void;
};
export const VideoListCarousel: React.FC<VideoListCarouselProps> = props => {
  const $ = _c(14);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($termSlug: String!) {
        videoLists(first: 8, where: { terms_some: { slug: $termSlug } }, orderBy: createdAt_DESC) {
          id
          shortDescription
          title
          slug
          people {
            id
            firstName
            lastName
            title
            companyName
            companyLogo {
              id
              url
            }
            avatar {
              id
              url
            }
          }
          terms {
            id
            name
            isPrimary
            slug
          }
          featuredImage {
            id
            url(transformation: { image: { resize: { fit: max, width: 1000 } } })
          }
          videos {
            videoPreviewUrl
            title
            slug
            shortDescription
            longDescription
            subtitle
            featuredImage {
              id
              url
            }
          }
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = props.term || "featured";
  let t2;
  if ($[1] !== t1) {
    t2 = {
      variables: {
        termSlug: t1
      }
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const query = useQuery(t0, t2);
  let t3;
  if ($[3] !== query.data) {
    t3 = [query.data];
    $[3] = query.data;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(_temp, t3);
  const course = query.data?.videoLists[0];
  useEducationContext();
  let t4;
  if ($[5] !== query.error) {
    t4 = query.error && <p>{"Error: "}{query.error.message}</p>;
    $[5] = query.error;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== course || $[8] !== props.carouselProps || $[9] !== query.data) {
    t5 = query.data && <Fade><CardCarousel spacing={6} title={course.terms[0]?.name} visibleCards={[1, 1, 2, 3, 3, 4]} controls={{
        top: TopControlTest,
        bottom: false
      }} fade={{
        startColor: "transparent",
        endColor: "#1F2128"
      }} {...props.carouselProps}>{query.data?.videoLists && [...query.data.videoLists].sort(_temp2).map(_temp3)}</CardCarousel></Fade>;
    $[7] = course;
    $[8] = props.carouselProps;
    $[9] = query.data;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <VStack align="center" height="full" justify="center" position="relative" width="full"><Box width="full">{t4}{t5}</Box></VStack>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
function _temp() {}
function _temp2(a, b) {
  if (b.people[0].companyLogo?.url && !a.people[0].companyLogo?.url) {
    return 1;
  }
  if (a.people[0].companyLogo?.url && !b.people[0].companyLogo?.url) {
    return -1;
  }
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
}
function _temp3(video) {
  return <VideoCard key={video.id} avatar={video.people[0].avatar.url} companyLogo={video.people[0].companyLogo?.url} firstName={video.people[0].firstName} image={video.featuredImage?.url} lastName={video.people[0].lastName} title={video.title} url={`/videos/${video.slug}/${video.videos[0]?.slug}?play=1`} video={video.videos[0]?.videoPreviewUrl} />;
}